import React from "react"

function FirstAidKit({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 11.5V9.5C13.5 8.95 13.95 8.5 14.5 8.5H21.5C22.05 8.5 22.5 8.95 22.5 9.5V11.5"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M8.5 13C8.5 12.17 9.17 11.5 10 11.5H26C26.83 11.5 27.5 12.17 27.5 13V27.5H8.5V13Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path d="M8.5 22.5H27.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M13.5 22.5V24.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M22.5 22.5V24.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M18 14.5V20" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M15.25 17.25H20.75" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default FirstAidKit
